import { createRoot } from 'react-dom/client';
import { LoginPage } from '../pages/LoginPage';

createRoot(document.getElementById('root')!).render(<LoginPage {...window.__PAGE_PROPS__} />);
